$( function () {	
	if ( !$( '#modalSizeChart' ).length )
		return false;

	function loadSizechart ( categories,id ) {
		var $container = $('#modalSizeChart .modal-body');
		var	sizechartfilter = categories || 0;
		var	product_id = id || 0;


		var	url = window.makeUrl( { module: 'eshop', manager: 'cms', action: 'list', type: 'new_size_guide', master : 'master_blank' } );

		if ( categories || id ) {
			
			url = window.makeUrl( { module: 'eshop', manager: 'cms', action: 'list', type: 'new_size_guide', sizechartFilterBy: sizechartfilter , productId: product_id , master : 'master_blank' } );
		}

		$.ajax({
			url: url,
			cache: false,
			dataType: "html",

			beforeSend: function ( xhr ) {
				xhr.setRequestHeader('X-Requested-With', 'empty');
				$container.empty().addClass('loading-secondary');
			},

			success: function ( responseText ) {
				$container.empty().append( responseText );
			},

			complete: function () {
				$(document).trigger('sizechart-modal');
				$container.removeClass('loading-secondary');
			}
		});
	}

	$( document ).on( 'click', '[data-sizechart-categories]', function(e){
		var categories = $(this).data('sizechart-categories');
		var id = $(this).data('sizechart-id');
		loadSizechart( categories, id );
	});
	
	//CM INCH SELECTOR
	$(document).on('click','[data-prop-selector]',function(){
		//DESELECT ALL
		$('[data-prop-selector]').removeClass('active');
		//SELECT CLICKED
		$(this).addClass('active');
		//HIDE ALL OPTIONS
		$('[data-prop]').addClass('hidden');
		//SHOW SELECTED OPTION
		$('[data-prop='+$(this).data('prop-selector')+']').removeClass('hidden');
	});
	
	//SIZE SELECTOR
	$(document).on('click','[data-size-selector]',function(){
		//DESELECT ALL
		$('[data-size-selector]').removeClass('active');
		//SELECT CLICKED
		$(this).addClass('active');
		//HIDE ALL OPTIONS
		$('[data-size]').addClass('hidden');
		//SHOW SELECTED OPTION
		$('[data-size='+$(this).data('size-selector')+']').removeClass('hidden');
	});
	
	//HIDE SIZE DISABLED
	$(document).on('sizechart-modal',function(){
		$('#modalSizeChart .right-box [data-size-selector]').addClass('hidden');
		$('#site_main > .product-details [data-option-id="2"] a').each(function(){
			var s=$(this).html().trim();
			//console.log($(this).html().trim());
			$('#modalSizeChart .right-box [data-size-selector="'+s+'"]').removeClass('hidden');
			//$(this).data('size-selector');
		});	
	});


	// Swap Show more/less button text
	$( '[data-zg-role="show-more-less"]').click( function( e ){
		if( $( this ).hasClass( 'collapsed') ){
			$( this ).find( '[data-zg-role="show-more-btn"]' ).addClass( 'hidden' );
			$( this ).find( '[data-zg-role="show-less-btn"]' ).removeClass( 'hidden' );
		}
		else {
			$( this ).find( '[data-zg-role="show-more-btn"]' ).removeClass( 'hidden' );
			$( this ).find( '[data-zg-role="show-less-btn"]' ).addClass( 'hidden' );
		}
	});

} );


//CM INCH SELECTOR
	$(document).on('click','[data-prop-selector]',function(){
		//DESELECT ALL
		$('[data-prop-selector]').removeClass('active');
		//SELECT CLICKED
		$(this).addClass('active');
		//HIDE ALL OPTIONS
		$('[data-prop]').addClass('hidden');
		//SHOW SELECTED OPTION
		$('[data-prop='+$(this).data('prop-selector')+']').removeClass('hidden');
	});
	
	//SIZE SELECTOR
	$(document).on('click','[data-size-selector]',function(){
		//DESELECT ALL
		$('[data-size-selector]').removeClass('active');
		//SELECT CLICKED
		$(this).addClass('active');
		//HIDE ALL OPTIONS
		$('[data-size]').addClass('hidden');
		//SHOW SELECTED OPTION
		$('[data-size='+$(this).data('size-selector')+']').removeClass('hidden');
	});
	
	//HIDE SIZE DISABLED
	$('#modalSizeChart').on('shown.bs.modal', function () {
		var $selectors = $('#modalSizeChart .right-box [data-size-selector]');
		$selectors.addClass('hidden');

		$('#site_main .product-details .right [data-option-id="2"] a').each(function () {
			var s = $(this).html().trim();
			console.log(s);
			$selectors.filter('[data-size-selector="' + s + '"]').removeClass('hidden');
		});
	});


	const checkAndHideSizeChart = () => {
		const bloccoTabella = document.querySelector('.sizechart-block');
		if (!bloccoTabella) {
			return;
		}

		const contenitoriOpzioni = document.querySelectorAll('.product-filters');
		let nascondiTabellaTaglie = false;

		contenitoriOpzioni.forEach(contenitore => {
			const opzioneImmagine = contenitore.querySelector('a.image-option');
			if (opzioneImmagine) {
				return;
			}

			const bottoni = contenitore.querySelectorAll('a.btn');
			if (bottoni.length === 1) {
				const testoBottone = bottoni[0].textContent.trim().toUpperCase();
				if (testoBottone === 'UNI') {
					nascondiTabellaTaglie = true;
				}
			}
		});

		if (nascondiTabellaTaglie) {
			bloccoTabella.style.display = 'none';
			observer.disconnect();
		}
	};

	const observer = new MutationObserver(checkAndHideSizeChart);

	observer.observe(document.body, {
		childList: true,
		subtree: true
	});